import { combineReducers } from "redux";
import * as actionTypes from "../action-mgr/actionTypes";

const stationDeviceFaultDeviceListInfo = (state = {}, action) => {
  switch (action.type) {
      case actionTypes.FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_REQUEST:
          return { ...state, error: null };
      case actionTypes.FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_SUCCESS:
          return {
              ...state,
              data: action.data,
              error: null
          };
      case actionTypes.FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_FAILURE:
          return { ...state, data: {}, error: action.error };
      default:
          return state;
  }
};

const stationDeviceFaultDatesInfo = (state = {}, action) => {
  switch (action.type) {
      case actionTypes.FETCH_STATION_DEVICE_FAULT_DATES_REQUEST:
          return { ...state, loading: true, error: null };
      case actionTypes.FETCH_STATION_DEVICE_FAULT_DATES_SUCCESS:
          return {
              ...state,
              loading: false,
              data: action.data, 
              error: null
          };
      case actionTypes.FETCH_STATION_DEVICE_FAULT_DATES_FAILURE:
          return { ...state, loading: false, data: {}, error: action.error };
      default:
          return state;
  }
};

// const queryDeviceFaultData = (state = [], action) => {
//   switch (action.type) {
//     case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null
//       };
//     case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_SUCCESS:
//       try {
//         const dataString = action.queryDeviceFaultData;
//         console.log("Received JSON string:", dataString);
//         const parsedData = JSON.parse(dataString);

//         return {
//           ...state,
//           deviceFaults: parsedData,
//           loading: false,
//           error: null
//         };
//       } catch (error) {
//         console.error("Parsing error:", error);
//         return {
//           ...state,
//           loading: false,
//           error: 'Failed to parse device fault data'
//         };
//       }
//     case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: action.message || 'Error fetching device fault data'
//       };
//     default:
//       return state;
//   }
// };

// prev version
// const queryDeviceFaultData = (state = { deviceFaults: [], loading: false, error: null }, action) => {
//   switch (action.type) {
//     case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null
//       };
//     case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_SUCCESS:
//       try {
//         const parsedData = JSON.parse(action.queryDeviceFaultData);
//         console.log("Parsed Data:", parsedData);

//         // Enhanced parsing logic
//         const deviceFaults = parsedData.map(entry => {
//           if (entry.devices) {
//             return entry.devices.map(device => ({
//               timestamp: entry.timestamp,
//               deviceName: device.deviceName,
//               deviceStatus: device.deviceStatus,
//               errorCodes: device.errorCodes,
//               distinctErrorCount: device.distinctErrorCount
//             }));
//           }
//           return { timestamp: entry.timestamp };
//         }).flat();

//         return {
//           ...state,
//           deviceFaults,
//           loading: false,
//           error: null
//         };
//       } catch (error) {
//         console.error("Parsing error:", error);
//         return {
//           ...state,
//           loading: false,
//           error: 'Failed to parse device fault data'
//         };
//       }
//     case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: action.message || 'Error fetching device fault data'
//       };
//     default:
//       return state;
//   }
// };

const queryDeviceFaultData = (state = { deviceFaults: [], deviceFaultsCount: [], loading: false, error: null }, action) => {
  switch (action.type) {
    case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_SUCCESS:
      try {
        const parsedData = action.queryDeviceFaultData;  // This is already a JavaScript object, no need to parse
        console.log("Parsed Data:", parsedData);

        let deviceFaults = [];
        let deviceFaultsCount = [];
        // Handle 'jsonArray' key
        if (parsedData.jsonArray) {
          const jsonArrayFaults = parsedData.jsonArray.map(entry => {
            if (entry.devices) {
              return entry.devices.map(device => ({
                timestamp: entry.timestamp,
                faultTm: device.faultTm, // Adding faultTm field 
                deviceName: device.deviceName,
                deviceBrand: device.deviceBrand,
                deviceModel: device.deviceModel,
                deviceStatus: device.deviceStatus,
                errorCodes: device.errorCodes,
                distinctErrorCount: device.distinctErrorCount
              }));
            }
            return { timestamp: entry.timestamp };
          }).flat();
          deviceFaults = deviceFaults.concat(jsonArrayFaults);
        }

        // Handle 'jsonArrayCount' key
        if (parsedData.jsonArrayCount) {
          const jsonArrayCountFaults = parsedData.jsonArrayCount.map(entry => {
            if (entry.devices) {
              return entry.devices.map(device => ({
                timestamp: entry.timestamp,
                deviceName: device.deviceName,
                distinctErrorCount: device.distinctErrorCount
              }));
            }
            return { timestamp: entry.timestamp };
          }).flat();
          deviceFaultsCount = deviceFaultsCount.concat(jsonArrayCountFaults);
        }

        return {
          ...state,
          deviceFaults,
          deviceFaultsCount,
          loading: false,
          error: null
        };
      } catch (error) {
        console.error("Reducer handling error:", error);
        return {
          ...state,
          loading: false,
          error: 'Failed to handle device fault data'
        };
      }
    case actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message || 'Error fetching device fault data'
      };
    default:
      return state;
  }
};


const selectedStationName = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATION:
      return action.stationName;
    default:
      return state;
  }
}

const selectedDeviceName = (state = "All", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DEVICE:
      return action.deviceName;
    default:
      return state;
  }
}

const selectedView = (state = "year", action) => {
  switch (action.type) {
    case actionTypes.SELECT_VIEW_PERIOD:
      return action.view;
    default:
      return state;
  }
}

//new Date().getDate()
const selectedDayStart = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DAY_START:
      return action.day;
    default:
      return state;
  }
}

//new Date().getMonth() + 1
const selectedMonthStart = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_MONTH_START:
      return action.month;
    default:
      return state;
  }
}

//new Date().getFullYear()
const selectedYearStart = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_YEAR_START:
      return action.year;
    default:
      return state;
  }
}


const selectedDayEnd = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DAY_END:
      return action.day;
    default:
      return state;
  }
}

//new Date().getMonth() + 1
const selectedMonthEnd = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_MONTH_END:
      return action.month;
    default:
      return state;
  }
}

//new Date().getFullYear()
const selectedYearEnd = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_YEAR_END:
      return action.year;
    default:
      return state;
  }
}
const systemDeviceFaultSummary = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_SYSTEM_DEVICE_FAULT_SUMMARY:
      return action.data.summary;
    default:
      return state;
  }
};

const systemDeviceFaultDetails = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_SYSTEM_DEVICE_FAULT_DETAILS:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
};

const systemDeviceFaultCount = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_SYSTEM_DEVICE_FAULT_COUNT:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
};

export default combineReducers({
  systemDeviceFaultSummary,
  systemDeviceFaultDetails,
  systemDeviceFaultCount,
  selectedStationName,
  stationDeviceFaultDeviceListInfo,
  stationDeviceFaultDatesInfo,
  selectedDeviceName,
  selectedView,
  queryDeviceFaultData,

  selectedDayStart,
  selectedMonthStart,
  selectedYearStart,
  selectedDayEnd,
  selectedMonthEnd,
  selectedYearEnd
});

const getCurrentState = state => state.systemDeviceFaults;
export const getSystemDeviceFaultSummary = state => getCurrentState(state).systemDeviceFaultSummary;
export const getSystemDeviceFaultDetails = state => getCurrentState(state).systemDeviceFaultDetails;
export const getSystemDeviceFaultCount = state => getCurrentState(state).systemDeviceFaultCount;

export const getSelectedStationName = state => getCurrentState(state).selectedStationName;
export const getStationDeviceFaultDeviceListInfo = state => getCurrentState(state).stationDeviceFaultDeviceListInfo;
export const getStationDeviceFaultDatesInfo = state => getCurrentState(state).stationDeviceFaultDatesInfo;
export const getQueryDeviceFaultData = state => getCurrentState(state).queryDeviceFaultData;

export const getSelectedDeviceName = state => getCurrentState(state).selectedDeviceName;

export const getSelectedView = state => getCurrentState(state).selectedView;

export const getSelectedMonthStart = state => getCurrentState(state).selectedMonthStart;
export const getSelectedYearStart = state => getCurrentState(state).selectedYearStart;
export const getSelectedDayStart = state => getCurrentState(state).selectedDayStart;
export const getSelectedMonthEnd = state => getCurrentState(state).selectedMonthEnd;
export const getSelectedYearEnd = state => getCurrentState(state).selectedYearEnd;
export const getSelectedDayEnd = state => getCurrentState(state).selectedDayEnd;


